import { useState, useEffect } from "react";

type OnlineStatusType = "offline" | "online";

/**
 * A service that checks if a user is online.
 * @returns onlineStatus: string, "online" or "offline" respective to user's connection to server.
 */
const useOnlineStatus = () => {
  const initialOnlineStatus = window.navigator.onLine ? "online" : "offline";

  const [onlineStatus, setOnlineStatus] = useState<OnlineStatusType>(initialOnlineStatus);

  useEffect(() => {
    const handleOffline = () => {
      setOnlineStatus("offline");
    };

    const handleOnline = () => {
      setOnlineStatus("online");
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  return { onlineStatus };
};

export default useOnlineStatus;
